import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';

const StudioPopup = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Çerez kontrolü
    const hasSeenPopup = localStorage.getItem('studioPopupSeen');

    if (!hasSeenPopup) {
      const timer = setTimeout(() => setShow(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setShow(false);
    localStorage.setItem('studioPopupSeen', 'true');
  };

  return (
    <>
      <style>
        {`
          /* MOBİL EKRANLAR İÇİN (Varsayılan Kurallar) */
          .studio-modal-body {
            overflow-y: auto; /* Form uzunsa aşağı kaydırmaya izin ver */
            overflow-x: hidden;
            max-height: 85vh; /* Ekranın %85'inden fazla yer kaplayıp taşmasın */
            border-radius: 8px;
            -webkit-overflow-scrolling: touch; /* Mobilde akıcı kaydırma hissi için */
          }
          .studio-iframe {
            display: block;
            width: 100%;
            height: 750px; /* Mobilde daralan form uzadığı için butona yer açacak garanti yükseklik */
            border: none;
          }
          
          /* PC EKRANLARI İÇİN (768px ve üzeri - Mevcut Harika Görünüm) */
          @media (min-width: 768px) {
            .studio-modal-body {
              overflow: hidden; /* PC'de kaydırma çubuğu gizli kalır */
              height: 500px;
              max-height: none;
            }
            .studio-iframe {
              width: 118%;
              height: 650px;
              transform: scale(0.85);
              transform-origin: top left;
            }
          }
        `}
      </style>

      <Modal show={show} onHide={handleClose} centered size="md">
        
        {/* Çarpı butonu - formun sağ üst köşesine kesin olarak sabitlendi */}
        <Modal.Header 
          closeButton 
          style={{ 
            position: 'absolute', 
            top: '10px', 
            right: '10px', 
            borderBottom: 'none', 
            zIndex: 1050 
          }} 
        />
        
        <Modal.Body className="p-0 studio-modal-body">
          
          <iframe 
            title="Brevo Subscription Form"
            src="https://5c5ee6ce.sibforms.com/v2/serve/MUIFAAfhnXXNPDhuAOE7-cdDBcA54RdjGvpgdh0KAsVC4ZgHpO5_ZOmB61XVz45AjThZP5wot-oZH9QIw5SpixdeRtLCq1U2ES5EqrnZMkpbYSAKc2k6aE9Nbi8nGmvJWzOFHj2AG0g0-Xz04C10WGLD06f5vhka9CEyGXM7aekQLIPj8FBEU0QXNy1TCOhH69rSFxRdOfFD0GFJ" 
            frameBorder="0" 
            scrolling="auto" /* Mobilde iç kaydırma gerekirse çalışsın diye "no" yerine "auto" yapıldı */
            allowFullScreen 
            className="studio-iframe"
          ></iframe>

        </Modal.Body>
      </Modal>
    </>
  );
};

export default StudioPopup;